import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { DirectionService } from '../../direction.service';

export interface InkGradientDialogData {
  file: any;
  serverAddress: string;
  userNameForFile: string;
  order?: any;
}

@Component({
  selector: 'app-ink-gradient-dialog',
  templateUrl: './ink-gradient-dialog.component.html',
  styleUrls: ['./ink-gradient-dialog.component.css'],
  host: {
    class: 'fill-screen-modal-phone',
  },
})
export class InkGradientDialogComponent implements OnInit, OnDestroy {
  isRTL = true;
  isDarkMode = false;
  private directionSub?: Subscription;
  private darkSub?: Subscription;

  file: any;
  serverAddress: string;
  userNameForFile: string;
  order: any;

  constructor(
    private directionService: DirectionService,
    private dialogRef: MatDialogRef<InkGradientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InkGradientDialogData
  ) {
    this.file = data?.file;
    this.serverAddress = data?.serverAddress ?? '';
    this.userNameForFile = data?.userNameForFile ?? '';
    this.order = data?.order;
  }

  ngOnInit(): void {
    this.directionSub = this.directionService.direction$.subscribe((dir) => {
      this.isRTL = dir === 'rtl';
    });
    this.darkSub = this.directionService.isDarkMode$.subscribe((d) => {
      this.isDarkMode = d;
    });
  }

  ngOnDestroy(): void {
    this.directionSub?.unsubscribe();
    this.darkSub?.unsubscribe();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  get fileName(): string {
    if (!this.file) {
      return '';
    }
    return this.file.originalFileName?.trim()
      ? this.file.originalFileName
      : (this.file.fileName || '');
  }

  get images(): any[] {
    return this.file?.images || [];
  }

  getPageNumber(image: any, index: number): number {
    return image?.page ?? index + 1;
  }

  roundPercent(num: number | null | undefined): string {
    if (num == null || Number.isNaN(num)) {
      return '—';
    }
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  getThumbnailUrl(image: any): string {
    if (!image?.thumbnailPath && !image?.path) {
      return '';
    }
    if (this.order) {
      const thumbPath = image.thumbnailPath || image.path || '';
      if (thumbPath.startsWith('http://') || thumbPath.startsWith('https://')) {
        return thumbPath;
      }
      if (thumbPath.startsWith('/home/ubuntu/IMG-Express')) {
        return thumbPath.replace('/home/ubuntu/IMG-Express', this.serverAddress);
      }
      if (
        this.order.status === 'PENDING' ||
        this.order.status === 'QR' ||
        this.order.status === 'NOT_PAID'
      ) {
        const fileName = thumbPath ? thumbPath.split(/[/\\]/).pop() : '';
        if (fileName && this.order.branchID?.serial_name) {
          return `https://${this.order.branchID.serial_name}.eazix.io/uploads/${this.order.user || ''}/${fileName}`;
        }
      }
      if (thumbPath) {
        return thumbPath;
      }
    }
    if (!image?.thumbnailPath) {
      return '';
    }
    const path = image.thumbnailPath;
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    const thumbnailFileName = path.split('/').pop();
    return `${this.serverAddress}/uploads/${this.userNameForFile}/${thumbnailFileName}`;
  }
}
